module.exports = __webpack_public_path__ + "static/media/coronarona.bad0cf34.jpg";